export default __webpack_public_path__ + "07194b7ccc9e273c2b2dfc31d7f158eb.png";